import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  password_match: {
    defaultMessage: 'Passwords do not match.',
    id: 'msp.register_form.error.password_match'
  },
  requirement: {
    defaultMessage: 'The password does not meet the security requirements.',
    id: 'msp.register_form.error.password_requirement'
  },
  invalid: {
    defaultMessage: 'Minimum age 18 years',
    id: 'msp.register_form.error.invalid_data'
  },
  existing_account: {
    id: 'msp.register_form.existing_account',
    defaultMessage:
      'The email address is already in use. You can use the "Reset password" function to set a new password.'
  },
  button: {
    defaultMessage: 'Register Now',
    id: 'msp.register_form.button_register'
  }
})

export const validateBirthDay = (date: string): boolean => {
  var today = new Date()
  var birthDate = new Date(date)
  var age = today.getFullYear() - birthDate.getFullYear()
  var m = today.getMonth() - birthDate.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age >= 18
}
